import { Icon } from '@eventbrite/eds-icon';
import { MegaphoneChunky } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { Fire } from './Fire';
import { useUrgencyMessages } from './provider';
import { UrgencyMessageType } from './types';
import './UrgencyMessages.scss';

export const UrgencyMessages: React.FC = () => {
    const values = useUrgencyMessages();

    const fewTicketsLeftUrgencySignal = values[
        UrgencyMessageType.FewTickets
    ] ? (
        <div className="urgencySignals-message urgencySignals-fewTickets_message">
            <Icon type={<Fire />} size="xsmall" />
            {gettext('Few tickets left')}
        </div>
    ) : null;

    const salesEndSoonUrgencySignal = values[
        UrgencyMessageType.SalesEndSoon
    ] ? (
        <div className="urgencySignals-message urgencySignals-salesEndSoon_message">
            <Icon
                type={<MegaphoneChunky />}
                size="small"
                color="boost-purple"
            />
            {gettext('Ticket sales end soon')}
        </div>
    ) : null;

    return (
        <>
            {fewTicketsLeftUrgencySignal}
            {salesEndSoonUrgencySignal}
        </>
    );
};
